import { gql } from "apollo-boost";

export default gql`
  mutation UpdateJob($id: ID, $input: JobInput!) {
    updateJob(id: $id, input: $input) {
      id
      contractNumber
      contractType
      primaryContractId
      contact {
        id
        firstName
        lastName
        otherFirstName
        otherLastName
      }
      franchise {
        id
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/UpdateJob.js